import { useState } from "react";

import { useNotification } from "@refinedev/core";
import _ from "lodash";

import { PhotoUpload } from "@/components/fields/photo-upload";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useVenueCreateForm } from "@/pages/venues/create/hooks/use-venue-create-form";

export const VenueAIEnrichmentStep = () => {
  const [instagramPageUrl, setInstagramPageUrl] = useState("");
  const [instagramScreenshot, setInstagramScreenshot] = useState("");
  const { open } = useNotification();
  const { basicInfoStep, aiEnrichmentStep, onAiEnrichmentStepSubmit } =
    useVenueCreateForm();

  return (
    <div className="space-y-4">
      {basicInfoStep && (
        <Card>
          <CardHeader>
            <CardTitle>Venue Information</CardTitle>
            <CardDescription>
              Current venue data to be enriched with AI-powered insights
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid gap-2">
              <div>
                <p className="text-sm font-medium">Name</p>
                <p className="text-sm text-muted-foreground">
                  {basicInfoStep.name}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium">Type</p>
                <p className="text-sm text-muted-foreground">
                  {basicInfoStep.type}
                </p>
              </div>
              <div>
                <p className="text-sm font-medium">Address</p>
                <p className="text-sm text-muted-foreground">
                  {basicInfoStep.address}
                </p>
              </div>
              {basicInfoStep.area && (
                <div>
                  <p className="text-sm font-medium">Area</p>
                  <p className="text-sm text-muted-foreground">
                    {basicInfoStep.area}
                  </p>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      )}
      {
        <div className="flex flex-col space-y-2">
          <Label htmlFor="#instagramPageUrlInput">Instagram Page Url</Label>
          <Input
            id="instagramPageUrlInput"
            value={instagramPageUrl}
            onChange={(e) => setInstagramPageUrl(e.target.value)}
            required
          />
          <Label htmlFor="#instagramPageUrlInput">Instagram Screenshot</Label>
          <PhotoUpload
            value={instagramScreenshot}
            onChange={(value) => {
              if (!value) {
                open?.({
                  type: "error",
                  message: "Error processing uploaded photo",
                });
                return;
              }
              setInstagramScreenshot(value);
            }}
            transformToWebP
          />
        </div>
      }

      {
        <div className="flex justify-center">
          <Button
            onClick={() => {
              onAiEnrichmentStepSubmit({
                instagramPageUrl,
                instagramScreenshot,
              });
            }}
            size="lg"
          >
            Next
          </Button>
        </div>
      }

      {/* {enrichmentResult && (
        <div className="flex flex-col gap-2">
          <VenueEnrichmentResult
            enrichment={enrichmentResult}
            updateEnrichment={(values) => {
              setEnrichmentResult(values);
              setIsDirty(true);
            }}
          />
          <div className="flex justify-end">
            <Button onClick={() => onSubmit(enrichmentResult, isDirty)}>
              Next Step
            </Button>
          </div>
        </div>
      )} */}
    </div>
  );
};
